import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Table } from "antd";
import requestcardColumns from "../../../const/Columns/requestcardColumns";
import { getCardRequests, dispatchCard } from "../../../apis/cardRequestsapis";

const Requestedcards = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [filteredList, setFilteredList] = useState([]);

  useEffect(() => {
    fetchRequests();
  }, []);

  // Run filtering only when request list or filters change
  useEffect(() => {
    const search = searchText.trim().toLowerCase();
    const filtered = requests?.filter((req) => {
      const displayStatus =
        req?.status === "pending" && req?.dispatchCard
          ? "dispatched"
          : (req?.status || "").toLowerCase();
      const userName = [req?.["user.firstName"], req?.["user.surname"]]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      const userEmail = (req?.["user.email"] || "").toLowerCase();

      const matchesSearch =
        !search || userName.includes(search) || userEmail.includes(search);
      const matchesStatus =
        !statusFilter || displayStatus === statusFilter.toLowerCase();

      return matchesSearch && matchesStatus;
    });
    setFilteredList(filtered || []);
  }, [searchText, statusFilter, requests]);

  const fetchRequests = async () => {
    setLoading(true);
    try {
      const res = await getCardRequests();
      console.log("fkljdslkfs", res.result);
      setRequests(res.result);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const dispatchStatus = async (body) => {
    setLoading(true);
    if (
      // eslint-disable-next-line no-restricted-globals
      confirm(
        "Are you sure that the card dispatch email notification has been sent?",
      )
    ) {
      const res = await dispatchCard(body);
      console.log("results", res);
      if (res?.success) {
        fetchRequests();
      } else {
        alert(res?.message);
      }
    }
    setLoading(false);
  };

  const columns = requestcardColumns(dispatchStatus);
  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="d-flex  justify-content-between  align-items-center">
              {/* <Link to="/addUser" className="btn add-new btn-primary mb-3">
                Raise a Request
              </Link> */}
              <div className="d-flex flex-column w-25">
                <label htmlFor="nameEmailInput" className="form-label">
                  Name / Email
                </label>
                <input
                  id="nameEmailInput"
                  type="text"
                  placeholder="Search by name or email"
                  className="form-control"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
              <div className="d-flex flex-column w-25">
                <label htmlFor="statusFilter" className="form-label">
                  Status
                </label>
                <select
                  id="statusFilter"
                  className="form-control"
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <option value="">All</option>
                  <option value="pending">Pending</option>
                  <option value="completed">Completed</option>
                  <option value="dispatched">Dispatched</option>
                </select>
              </div>
            </div>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className="table-respoinsive" style={{ overflowX: "auto" }}>
                <Table
                  columns={columns}
                  dataSource={filteredList}
                  className="table-striped"
                  rowKey={(record) => record.id}
                  // scroll={{ y: 400 }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Requestedcards;
